import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../../environments/environment";
import * as HSET from "../settings";
import { GenericHttpService } from "../../../../services/generic-http.service";

@Injectable()
export class PerformanceDashboardEndToEndSlaService {
  apiUrl = environment.gateWayHost;
  editItem: any;
  constructor(public generic: GenericHttpService) {}

  getEndToEndSLA(url, params) {
    const option = {
      method: "GET",
      // url: `${this.apiUrl}${this.apiUrlConstant.getOverallOtif}`,
      url: url, // "./assets/data/p-d-otif.json",
      query: params
    };
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.processEndToEndSLA)
    );
  }

  processEndToEndSLA(data: any) {
    if (data.data.length === 0) return null;
    const underProcess = [],
      sla = [],
      quantity = [];
    let dataKeys = [];
    let allKey = "All";
    let __v2Data = data.data[0].TransportationSlaV2;
    delete __v2Data["data"];
    if (Object.keys(__v2Data).length > 1) {
      dataKeys = Object.keys(__v2Data);
    } else if (Object.keys(__v2Data).length === 1) {
      allKey = Object.keys(__v2Data)[0];
      __v2Data = __v2Data[Object.keys(__v2Data)[0]];
      delete __v2Data["data"];

      if (Object.keys(__v2Data).length > 1) {
        dataKeys = Object.keys(__v2Data);
      } else if (Object.keys(__v2Data).length === 1) {
        allKey = Object.keys(__v2Data)[0];
        __v2Data = __v2Data[Object.keys(__v2Data)[0]];
        delete __v2Data["data"];
        dataKeys = Object.keys(__v2Data);
      }
    }
    const chart1 = { underProcess: 0, sla: 0, allKey: allKey };
    if (dataKeys.length) {
      dataKeys.map(_dataName => {
        // this map is being used typically like a for loop
        const total =
          __v2Data[_dataName]["data"]["breached_quantity"] +
          __v2Data[_dataName]["data"]["non_breached_quantity"];

        const __underProcess = Number(
          (
            (100 * __v2Data[_dataName]["data"]["in_process_quantity"]) /
            total
          ).toFixed(2)
        );
        underProcess.push(__underProcess);
        chart1["underProcess"] += __underProcess;

        const __sla = Number(
          (
            (100 * __v2Data[_dataName]["data"]["non_breached_quantity"]) /
            total
          ).toFixed(2)
        );
        sla.push(__sla);
        chart1["sla"] += __sla;

        quantity.push(total+ __v2Data[_dataName]["data"]["in_process_quantity"]);
      });
    }
    const chart2 = { underProcess, sla, quantity, dataKeys };
    return { chart1, chart2 };
  }

  createChart(chartData, Options) {
    const chart1 = JSON.parse(JSON.stringify(HSET.chart1));
    const chart2 = JSON.parse(JSON.stringify(HSET.chart2));

    chart1.series[0].data = [chartData.chart1.underProcess];
    chart1.series[1].data = [chartData.chart1.sla];
    chart1.xAxis.categories = [chartData.chart1.allKey];

    chart2.series[0].data = chartData.chart2.underProcess;
    chart2.series[1].data = chartData.chart2.sla;
    chart2.series[2].data = chartData.chart2.quantity;
    chart2.xAxis.categories = chartData.chart2["dataKeys"];

    return { chart1, chart2 };
  }
}
